/*
 * Returns the full odometer formatted value of a vehicle.
 */
export function vehicleToOdometerFull(record: {
  lastOdometerTracking?: {
    value: number;
  };
  odometerUnit?: string | null;
}): string {
  // Check
  if (!record) {
    return '';
  }

  const odometerValue = record.lastOdometerTracking
    ? record.lastOdometerTracking.value
    : 0;

  return `${odometerValue}` + ` ${record.odometerUnit || ''}`;
}
